import { useFilterValue } from '@btime/react-contexts'
import React from 'react'

import { getSelectedPlacesValues } from './_helpers/selectedPlaces'
import { useFilterValueText } from '../../../utils/helpers/filters'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import FullPlacesFilterSideModal from './FullPlacesFilterSideModal'
import PlacesFilterSideModal from './PlacesFilterSideModal'

const PlacesFilter = ({ label, field, placeLevelField, icon, full, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  field = field || 'placeIds'
  placeLevelField = placeLevelField || 'placeLevelIds'
  label = label || 'Locais'

  const placeValue = useFilterValue(field, [])
  const placeLevelValue = useFilterValue(placeLevelField, [])

  const value = useFilterValue(field, [])
  let selectedValue = useFilterValueText(field)
  const placeLevelSelectedValue = useFilterValueText(placeLevelField)
  if (presentation === 'bar') {
    selectedValue = selectedValue || placeLevelSelectedValue
  } else {
    selectedValue = getSelectedPlacesValues(value, props.type)
  }

  const Modal = full ? FullPlacesFilterSideModal : PlacesFilterSideModal
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && (icon || 'RiMapPinLine')}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <Modal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default PlacesFilter
